import React, { useState, useEffect } from "react";
import "./Process.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { GiUnicorn, GiPisaTower, GiGoldBar, GiMagnet } from "react-icons/gi";
import { TbLayersDifference } from "react-icons/tb";
import Fade from "react-reveal/Fade";

const Main = () => {
  const [processItems, setProcessItems] = useState([]);

  useEffect(() => {
    // Simulate fetching data from an API
    const fetchData = () => {
      const items = [
        {
          icon: <GiUnicorn className="aniItemIcon" />,
          title: "Unique",
          description: "Memorable & perfect for gold-based businesses.",
          iconClass: "",
        },
        {
          icon: <GiPisaTower className="aniItemIconBlue" />,
          title: "Recognizable",
          description: "Enhances brand recognition & stands out.",
          iconClass: "blue",
        },
        {
          icon: <TbLayersDifference className="aniItemIconOrange" />,
          title: "Differentiation",
          description: "Distinguishes your brand from the ordinary.",
          iconClass: "orange",
        },
        {
          icon: <GiMagnet className="aniItemIcon" />,
          title: "Attractive",
          description: "Captivates attention & remains unforgettable.",
          iconClass: "",
        },
        {
          icon: <GiGoldBar className="aniItemIconBlue" />,
          title: "Defines You",
          description: "Sets a standard for online distinction.",
          iconClass: "blue",
        },
      ];

      setProcessItems(items);
    };

    fetchData();
  }, []);

  return (
    <Fade bottom>
      <div className="a-container a-padding pattern-bg2">
        {/* <img src={line1} alt="" /> */}
        <div className=" h-[1px] md:w-[60%]  m-auto  line-div"></div>
        <div className="why-gold">
          <section className="processContainer" id="processContainer">
            <Fade bottom>
              <h1 className="title">
                Why <span className="text-pent"> .Gold Domain</span> extension ?
              </h1>
              {/* <p className="home-subtitle ">
                .Gold domains signify prestige, enhancing trust, and uniqueness
                in online branding
              </p> */}
            </Fade>
            <Fade bottom>
              <div className="container">
                <div className="row justify-center gap-[1rem] py-[1rem]">
                  {processItems.map((item, index) => (
                    <div
                      key={index}
                      className="col-12 col-md-6 col-lg-4 col-xl-2 text-center"
                    >
                      {/* <CiCircleCheck className="icon-process" /> */}
                      <div className="w-full flex justify-center">
                        <span className="text-[28px] w-fit mb-[1rem] icon-process p-[12px] rounded-[30px]">
                          {item.icon}
                        </span>
                      </div>
                      <div className="processAnimationText">
                        <h3 className="!font-semibold text-[22px] !text-black pb-[1rem]">
                          {item.title}
                        </h3>
                        <p className="paragraph">{item.description}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </Fade>
          </section>
        </div>
      </div>
    </Fade>
  );
};

export default Main;
